<template>
    <v-col
            cols="12"
            class="px-0"
    >
        <v-card>
            <v-card-text class="py-0">
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        <v-card-title class="subheading font-weight-bold pa-0">{{ role.name }}</v-card-title>
                    </v-col>
                    <v-col cols="6" lg="3" class="px-0">
                        <v-chip
                                class="ma-2"
                                color="green"
                                text-color="white"
                                @click="handleShow('users')"
                        >
                            <v-avatar
                                    left
                                    class="green darken-4"
                            >
                                {{role.Users.length}}
                            </v-avatar>
                            Users
                        </v-chip>
                    </v-col>
                    <v-col cols="6" lg="3" class="px-0">
                        <v-chip
                                class="ma-2"
                                color="primary"
                                text-color="white"
                                @click="handleShow('permissions')"
                        >
                            <v-avatar left class="primary darken-4">{{role.Permissions.length}}</v-avatar>
                            Permissions
                        </v-chip>
                    </v-col>
                    <v-col cols="6" lg="1" class="text-left text-lg-right">
                        <v-btn icon @click="handleEdit(role)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" lg="1" class="text-right">
                        <v-btn icon @click="show = !show">
                            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-expand-transition>
                <div v-show="show">
                    <v-divider></v-divider>
                    <v-card-text v-show="showInfo === 'users'">
                        <h3>Users</h3>
                        <v-chip-group
                                column
                        >
                            <v-chip v-for="user in role.Users" :key="user.id" color="green" text-color="white" label>
                                {{ user.name }} ({{user.id}})
                            </v-chip>
                        </v-chip-group>
                    </v-card-text>
                    <v-card-text v-show="showInfo === 'permissions'">
                        <h3>Permissions</h3>
                        <v-chip-group
                                column
                        >
                            <v-chip v-for="permission in role.Permissions" :key="permission.id" color="primary" label>
                                {{permission.Application.name}}: {{ permission.name }}
                            </v-chip>
                        </v-chip-group>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </v-col>
</template>

<script>
export default {
  props: ['role'],
  data() {
    return {
      showInfo: 'permissions',
      show: false,
    };
  },
  methods: {
    handleEdit(role) {
      this.$emit('edit', role);
    },
    handleShow(info) {
      if (this.showInfo === info && this.show) {
        this.show = false;
      } else {
        this.showInfo = info;
        this.show = true;
      }
    },
  },
  name: 'Role',
};
</script>

<style scoped lang="sass">
</style>
